import React from 'react'
import ConnectorListing from './ConnectorListing/ConnectorListing'
import SelectIntegrationSkeleton from '../../../../../SharedComponents/Skeletons/SelectIntegrationSkeleton'
import { useGetEgeIntegrationsQuery } from '../../../../../../features/marketplace/marketplaceApi'

const SelectEGEConnector = () => {
    const { data: integrations = [], isLoading } = useGetEgeIntegrationsQuery()

    return (
        <>
            <div className="Selectconnectorewfine">
                <h4 className="newconnector-sub-title">
                    <span className="float-left">Select an Integration Type</span>
                    <span className="clearfix"></span>
                </h4>
            </div>
            {isLoading ? (
                <SelectIntegrationSkeleton />
            ) : (
                <div className="row mt-3 padding-20-new">
                    {integrations.map((integration) => (
                        <ConnectorListing key={integration.id} integration={integration} />
                    ))}
                </div>
            )}
        </>
    )
}

export default SelectEGEConnector
